import { Checkbox, Select } from 'antd'
import { OptionProps } from 'antd/lib/select'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { ProductFilter } from './ProductFilter'
import { IBaseCategory } from '@getgreenline/homi-shared'
import { CheckboxChangeEvent } from 'antd/lib/checkbox'
import { TagModels } from '@getgreenline/tags'

interface TagSelectProps {
  productFilter: ProductFilter
  tags: TagModels.ITagContract[]
  filterOption: (input: string, option: React.ReactElement<OptionProps>) => boolean
}

export const TagSelect = observer(({ productFilter, tags, filterOption }: TagSelectProps) => {
  const onChangeTag = (e: CheckboxChangeEvent, tag: TagModels.ITagContract) => {
    const { selectedTagIds } = productFilter.productFilter
    const { id: tagId } = tag
    if (e.target.checked) {
      if (selectedTagIds) {
        productFilter.setSelectedTagIds([...selectedTagIds, tagId])
      } else {
        productFilter.setSelectedTagIds([tagId])
      }
    } else {
      if (selectedTagIds) {
        productFilter.setSelectedTagIds(
          selectedTagIds.filter((selectedTagId: string) => selectedTagId !== tagId),
        )
      }
    }
  }

  return (
    <Select<string[]>
      className='gr-filter-item gr-filter-gutter antd-v3-select-override'
      showSearch
      showArrow
      placeholder={'Tags (none)'}
      mode='multiple'
      maxTagCount={0}
      maxTagPlaceholder={
        productFilter.productFilter.selectedTagIds?.length === tags.length
          ? `Tags (all)`
          : `Tags (${productFilter.productFilter.selectedTagIds?.length})`
      }
      menuItemSelectedIcon={<></>}
      value={productFilter.productFilter.selectedTagIds}
      filterOption={filterOption}
    >
      <Select.Option
        style={{
          borderBottom: '1px solid #e8e8e8',
        }}
        key='all'
      >
        <Checkbox
          className='w-100'
          checked={productFilter.productFilter.selectedTagIds?.length === tags.length}
          onChange={(e) => {
            e.target.checked
              ? productFilter.setSelectedTagIds(tags.map(({ id }) => id))
              : productFilter.setSelectedTagIds([])
          }}
        >
          <b>Select All</b>
        </Checkbox>
      </Select.Option>
      {tags.map((tag) => (
        <Select.Option title={tag.name} key={tag.id} value={tag.id}>
          <Checkbox
            checked={productFilter.productFilter.selectedTagIds?.includes(tag.id)}
            className='w-100'
            onChange={(e) => onChangeTag(e, tag)}
          >
            {tag.name}
          </Checkbox>
        </Select.Option>
      ))}
    </Select>
  )
})
